import React, { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";
import { ButtonContainer } from "./elements/ButtonContainer";
import { SerializedStyles } from "@emotion/react";
import { withIsVisible } from "utils/reactUtils";
import { Text, TextSize } from "../Text";
import { GlobalStore } from "../../../store/global/GlobalStore";

interface ButtonProps {
  navigateTo?: string;
  onClick?: () => void;
  text?: string;
  size?: TextSize<"Button">;
  height?: number;
  buttonType?: "primary" | "secondary";
  shape?: "round" | "square";
  widthExpand?: boolean;
  buttonCss?: SerializedStyles;
}

export const Button = withIsVisible(
  ({
    navigateTo,
    onClick,
    text,
    size,
    buttonType,
    shape = "round",
    height,
    widthExpand = false,
    buttonCss,
    children,
  }: PropsWithChildren<ButtonProps>) => {
    const navigate = useNavigate();
    const theme = GlobalStore.useState(s => s.theme);
    return (
      <ButtonContainer
        onClick={() => {
          if (onClick) {
            onClick();
          }
          if (navigateTo) {
            navigate(navigateTo);
          }
        }}
        buttonType={buttonType}
        shape={shape}
        height={height}
        widthExpand={widthExpand}
        css={buttonCss}
      >
        {children ? (
          children
        ) : (
          <Text
            textStyle="Button"
            size={size ?? "Large"}
            color={
              buttonType === "secondary"
                ? theme.button.secondary.text.default
                : theme.button.primary.text.default
            }
          >
            {text}{" "}
          </Text>
        )}
      </ButtonContainer>
    );
  }
);
